import React from 'react';
import SectionLayout from 'src/app/atoms/Layout/Section/SectionLayout';
import MightyProLinkTextBlock from 'src/app/organisms/Homepage/MightyProLinkTextBlock/MightyProLinkTextBlock';

const MightyProLink = (): JSX.Element => (
  <SectionLayout
    padding={['spacing-7xl', 'spacing-4xl']}
    paddingSm={['spacing-4xl', 'spacing-xl']}
    maxWidth='width-3xl'
    data-track-section='mighty-pro-link'
  >
    <MightyProLinkTextBlock />
  </SectionLayout>
);

export default MightyProLink;
